module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Live Class Teacher',
          to: {
            path: '/live-class-teacher'
          },
        },
        {
          text: 'Live Class Detail'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Live Class Detail")]), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-0 px-0 pb-3 mb"
  }, [_c('v-btn', {
    staticClass: "mr-2",
    class: _vm.tab == 3 ? 'darkFade--text' : 'white--text',
    attrs: {
      "id": "set-class",
      "color": _vm.tab == 3 ? 'white' : 'blew',
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Set Kelas")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    class: _vm.tab == 3 ? 'white--text' : 'darkFade--text',
    attrs: {
      "id": "on-live-class",
      "color": _vm.tab == 3 ? 'blew' : 'white',
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.tab = 3
      }
    }
  }, [_vm._v("On Live Class")])], 1), _vm._v(" "), _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 1),
      expression: "tab == 1"
    }]
  }, [_c('v-card-title', [_vm._v("\n            Quiz\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    attrs: {
      "text": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": _vm.addQuiz
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-plus-circle ")]), _vm._v(" Tambah\n                Quiz\n            ")], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-5"
  }, [_c('div', {
    staticClass: "mt-5 blue--text"
  }, [_c('v-select', {
    staticClass: "select_box my-2",
    staticStyle: {
      "background-color": "#e8f5fa"
    },
    attrs: {
      "id": "select_quiz",
      "items": _vm.quiz,
      "item-text": "name",
      "item-value": "id",
      "height": "36px",
      "placeholder": "Pilih Quiz",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getQuizId(_vm.quizSelected)
      }
    },
    model: {
      value: (_vm.quizSelected),
      callback: function($$v) {
        _vm.quizSelected = $$v
      },
      expression: "quizSelected"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-select', {
    staticClass: "select_box my-5",
    attrs: {
      "id": "select_duration",
      "items": _vm.duration,
      "item-text": "name",
      "item-value": "id",
      "height": "36px",
      "placeholder": "Pilih Durasi",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.timer),
      callback: function($$v) {
        _vm.timer = $$v
      },
      expression: "timer"
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "grey lighten-5 text-center"
  }, [_c('v-row', {
    staticClass: "blue--text mb-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', {
    staticClass: "pa-2 pr-5"
  }, [_vm._v(" Opsi")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('span', {
    staticClass: "pa-2"
  }, [_vm._v(" Kunci")])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      key: index
    }, [_c('v-row', {
      staticClass: "blue--text my-5"
    }, [_c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('v-btn', {
      staticClass: "blue--text",
      attrs: {
        "fab": "",
        "depressed": ""
      }
    }, [_vm._v("\n                                    " + _vm._s(option.choice) + "\n                                ")])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "8"
      }
    }, [_c('v-select', {
      staticClass: "select_key mt-1",
      staticStyle: {
        "background-color": "#e8f5fa"
      },
      attrs: {
        "items": _vm.keyOptions,
        "item-text": "name",
        "item-value": "name",
        "max-width": "10px",
        "outlined": "",
        "rounded": "",
        "hide-details": ""
      },
      model: {
        value: (option.answer),
        callback: function($$v) {
          _vm.$set(option, "answer", $$v)
        },
        expression: "option.answer"
      }
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex py-3 px-3 justify-center align-center"
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "width": "100%",
      "depressed": "",
      "color": "#2690cb"
    },
    on: {
      "click": _vm.setQuiz
    }
  }, [_vm._v("Save")])], 1)], 2)], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 3),
      expression: "tab == 3"
    }]
  }, [(
    _vm.statusLive != 'STARTED' &&
    _vm.statusLive != 'DISABLED_CHAT' &&
    _vm.statusLive != 'DIVERTED'
  ) ? _c('v-card', {
    staticClass: "mb-5 pb-3"
  }, [_c('div', {
    staticClass: "d-flex py-3 px-3 rounded-tl justify-center align-center"
  }, [_c('h4', [_vm._v("Tidak Sedang Live")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex py-2 px-3 rounded-tl justify-center align-center"
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "width": "100%",
      "depressed": "",
      "color": "#6FCF97"
    },
    on: {
      "click": _vm.startLiveClass
    }
  }, [_vm._v("Mulai Live")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusLive == 'STARTED' || _vm.statusLive == 'DISABLED_CHAT') ? _c('v-card', {
    staticClass: "mb-5 pb-3"
  }, [_c('div', {
    staticClass: "d-flex py-2 px-3 rounded-tl justify-center align-center"
  }, [_c('h4', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "#FF647C"
    }
  }, [_vm._v("mdi-circle")]), _vm._v(" Sedang\n                    Live\n                ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex py-2 px-3 rounded-tl justify-center align-center"
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "width": "100%",
      "depressed": "",
      "color": "#FF647C"
    },
    on: {
      "click": function($event) {
        _vm.isEndLive = true
      }
    }
  }, [_vm._v("Hentikan Live")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusLive == 'DIVERTED') ? _c('v-card', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "d-flex py-3 px-3 rounded-tl justify-center align-center"
  }, [_c('h4', [_vm._v("Live Class Dialihkan")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex py-3 px-3 rounded-tl justify-center align-center"
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "width": "100%",
      "depressed": "",
      "disabled": "",
      "color": "#FF647C"
    }
  }, [_vm._v("Mulai Live Class")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex py-3 px-3 rounded-tl justify-center align-center"
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "width": "100%",
      "depressed": "",
      "color": "#2690cb"
    },
    on: {
      "click": _vm.onWaitingClass
    }
  }, [_vm._v("Kembali ke Live Stream")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n                    Live Chat\n                    "), _c('v-spacer'), _vm._v(" "), (!_vm.isDisabled) ? _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "depressed": "",
      "color": "#FF647C"
    },
    on: {
      "click": _vm.disabledChat
    }
  }, [_vm._v("Disable Chat")]) : _vm._e(), _vm._v(" "), (_vm.isDisabled) ? _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "depressed": "",
      "color": "#6FCF97"
    },
    on: {
      "click": _vm.enabledChat
    }
  }, [_vm._v("Enable Chat")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0 pt-0"
  }, [
    [
      [_c('v-sheet', {
        staticClass: "overflow-y-auto pt-2",
        staticStyle: {
          "max-height": "300px"
        },
        style: (_vm.$vuetify.breakpoint.lgAndUp ?
          'height: 79%' :
          'height: 79%'),
        attrs: {
          "id": "scroll-target"
        }
      }, _vm._l((_vm.messages), function(message, index) {
        return _c('div', {
          key: index
        }, [(message.type === 1) ? _c('v-row', {
          staticClass: "text-right py-2",
          class: _vm.$vuetify.breakpoint.smAndDown ?
            'mx-2' :
            'mx-3',
          attrs: {
            "justify": message.user_id ===
              _vm.$store.state.usman.user_id ?
              'end' :
              'start',
            "align": "end"
          }
        }, [_c('v-col', {
          staticClass: "pa-1 text-left",
          attrs: {
            "cols": "1",
            "align-self": "center"
          }
        }, [_c('v-avatar', {
          attrs: {
            "left": "",
            "size": "30"
          }
        }, [_c('v-img', {
          attrs: {
            "src": message.url_img
          }
        })], 1)], 1), _vm._v(" "), _c('v-col', {
          staticClass: "text-left",
          attrs: {
            "cols": "11",
            "align-self": "center"
          }
        }, [_c('div', {
          staticClass: "roboto-text text-left font-weight-200 putih--text",
          class: message.user_id ===
            _vm.$store.state.usman
            .user_id ?
            '' :
            '',
          staticStyle: {
            "font-size": "14px",
            "padding-left": "10px"
          },
          style: (message.user_id ===
            _vm.$store.state.usman
            .user_id ?
            'color: #464958' :
            'color: #181818'),
          attrs: {
            "elevation": "2",
            "max-width": _vm.$vuetify.breakpoint
              .smAndDown ?
              172 :
              443
          }
        }, [(
          message.user_name &&
          message.user_id !==
          _vm.$store.state
          .usman
          .user_id
        ) ? _c('span', {
          staticClass: "grey--text mr-1"
        }, [_vm._v("\n                                                    " + _vm._s(message.user_name) + "\n                                                ")]) : _vm._e(), _vm._v(" "), (
          message.user_name &&
          message.user_id ===
          _vm.$store.state
          .usman
          .user_id
        ) ? _c('span', {
          staticClass: "grey--text mr-1"
        }, [_vm._v("\n                                                    Anda\n                                                ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(message.message))])])])], 1) : _vm._e()], 1)
      }), 0)]
    ]
  ], 2), _vm._v(" "), (!_vm.isDisabled) ? _c('v-card-actions', {
    staticClass: "d-flex pa-2 py-3 border-top-1 card-actions"
  }, [
    [_c('v-text-field', {
      staticClass: "searchbar rounded-pill ma-1",
      staticStyle: {
        "padding-right": "30px"
      },
      attrs: {
        "rounded": "",
        "height": "37px",
        "hide-details": "",
        "placeholder": "Ketik pesanmu"
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.message && !_vm.chatLoading ?
            _vm.saveMessage(1) :
            null
        }
      },
      model: {
        value: (_vm.message),
        callback: function($$v) {
          _vm.message = $$v
        },
        expression: "message"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "chat-btn mr-5",
      attrs: {
        "depressed": "",
        "color": "#67bbdf",
        "rounded": "",
        "min-width": "36px",
        "min-height": "36px",
        "dark": "",
        "loading": _vm.chatLoading
      },
      on: {
        "click": function($event) {
          _vm.message && !_vm.chatLoading ?
            _vm.saveMessage(1) :
            null
        }
      }
    }, [(!_vm.chatLoading) ? _c('svg', {
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 20 20",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M10.8151 10.1968L3.28308 11.4528C3.19649 11.4673 3.11522 11.5043 3.04746 11.5601C2.97971 11.6159 2.92784 11.6886 2.89708 11.7708L0.30008 18.7278C0.0520799 19.3678 0.72108 19.9778 1.33508 19.6708L19.3351 10.6708C19.4598 10.6086 19.5646 10.5128 19.6379 10.3943C19.7112 10.2758 19.75 10.1392 19.75 9.99984C19.75 9.86049 19.7112 9.72389 19.6379 9.60537C19.5646 9.48685 19.4598 9.39109 19.3351 9.32884L1.33508 0.32884C0.72108 0.0218396 0.0520799 0.63284 0.30008 1.27184L2.89808 8.22884C2.92869 8.31125 2.9805 8.38414 3.04827 8.44014C3.11604 8.49615 3.19737 8.5333 3.28408 8.54784L10.8161 9.80284C10.8624 9.81096 10.9044 9.83516 10.9347 9.8712C10.965 9.90723 10.9816 9.95278 10.9816 9.99984C10.9816 10.0469 10.965 10.0925 10.9347 10.1285C10.9044 10.1645 10.8624 10.1887 10.8161 10.1968H10.8151Z",
        "fill": 'white'
      }
    })]) : _vm._e()])]
  ], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-tabs', [_c('v-tab', [_vm._v(" Quiz ")]), _vm._v(" "), _c('v-tab', [_vm._v("\n                    Participant\n                    "), _c('v-btn', {
    staticClass: "ml-2 white--text",
    attrs: {
      "depressed": "",
      "rounded": "",
      "small": "",
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-account-multiple ")]), _vm._v("\n                        " + _vm._s(_vm.studentCount) + "\n                    ")], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    staticClass: "pa-3 pt-3"
  }, _vm._l((_vm.arrayQuiz), function(quiz, index) {
    return _c('v-card', {
      key: index,
      staticClass: "d-flex justify-space-around border-top-divider",
      attrs: {
        "flat": "",
        "tile": "",
        "color": "rgba(230, 230, 230, 0.08)"
      }
    }, [_c('v-card-text', [_c('v-layout', [_c('span', {
      staticClass: "py-2 px-2 blue--text"
    }, [_vm._v("\n                                    Quiz " + _vm._s(index + 1) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "px-5 ml-3 white--text",
      attrs: {
        "depressed": "",
        "color": _vm.quiz_active === index + 1 ?
          'success' :
          'primary'
      },
      on: {
        "click": function($event) {
          return _vm.getDetailQuiz(index + 1)
        }
      }
    }, [_vm._v("\n                                    Publish\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "px-5 ml-3 white--text",
      attrs: {
        "depressed": "",
        "color": "success",
        "disabled": _vm.quiz_active !== index + 1
      },
      on: {
        "click": function($event) {
          return _vm.getResultQuiz(index + 1)
        }
      }
    }, [_vm._v("\n                                    Live Quiz\n                                ")]), _vm._v(" "), (_vm.show_result === '') ? _c('v-btn', {
      staticClass: "px-5 ml-3 white--text",
      attrs: {
        "depressed": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.getResult(index + 1)
        }
      }
    }, [_vm._v("\n                                    Result\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.show_result !== '') ? _c('v-btn', {
      staticClass: "px-5 ml-3 white--text",
      attrs: {
        "depressed": "",
        "color": "#FF647C"
      },
      on: {
        "click": function($event) {
          return _vm.removeStatus()
        }
      }
    }, [_vm._v("\n                                    End Result\n                                ")]) : _vm._e()], 1), _vm._v(" "), (
      _vm.showResultDialog &&
      _vm.quiz_active === index + 1
    ) ? _c('div', {
      staticClass: "mt-5",
      staticStyle: {
        "margin-left": "60px"
      }
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pt-3"
    }, [_c('div', {
      staticClass: "roboto-text darkblue--text font-weight-700 mb-3",
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("\n                                                    Live Quiz\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "text-left",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v("\n                                                    Submission :\n                                                    "), _c('b', [_vm._v("\n                                                        " + _vm._s(_vm.answer_count) + "/" + _vm._s(_vm.studentCount) + "\n                                                        (" + _vm._s(_vm.quiz_percentation) + "%) Jawaban")])]), _vm._v(" "), _c('div', {
      staticClass: "text-left mt-5"
    }, [_c('v-btn', {
      attrs: {
        "color": "#E6F8FF",
        "depressed": ""
      }
    }, [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v("\n                                                            " + _vm._s(_vm.countdown_quiz) + "\n                                                        ")])])], 1), _vm._v(" "), (
      _vm.answer_count <= 0 &&
      !_vm.loading_answer
    ) ? _c('div', {
      staticClass: "text-center mt-5 darkblue--text font-weight-600",
      staticStyle: {
        "font-size": "16px",
        "padding": "10px 0px",
        "background-color": "#f3f5f7"
      }
    }, [_vm._v("\n                                                    Belum ada yang menjawab\n                                                    Quiz\n                                                ")]) : _vm._e(), _vm._v(" "), _c('div', [(
      _vm.showResultDialog
    ) ? _c('BarChart', {
      attrs: {
        "data": _vm.data_chart
      }
    }) : _vm._e()], 1)])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
  }), 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    staticClass: "border-top-divider mt-2 mb-5",
    attrs: {
      "flat": "",
      "tile": "",
      "color": "rgba(230, 230, 230, 0.08)"
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "mt-2",
    staticStyle: {
      "max-height": "400px",
      "overflow": "auto"
    }
  }, _vm._l((_vm.studentList), function(student, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-2 pa-2",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-text', [_c('v-row', [_c('v-col', {
      staticClass: "pt-1",
      attrs: {
        "cols": "8"
      }
    }, [_c('span', {
      staticClass: "darkblue--text",
      staticStyle: {
        "font-size": "16px"
      },
      attrs: {
        "block": ""
      }
    }, [_vm._v("\n                                                    " + _vm._s(student.name) + "\n                                                ")])]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "4"
      }
    }, [(
      student.suspend ==
      false
    ) ? _c('v-btn', {
      staticClass: "px-5 ml-2 white--text",
      attrs: {
        "depressed": "",
        "color": "#FF647C"
      },
      on: {
        "click": function($event) {
          return _vm.onConfirmSuspend(
            student.id
          )
        }
      }
    }, [_vm._v("\n                                                    Suspend\n                                                ")]) : _vm._e(), _vm._v(" "), (
      student.suspend ==
      true
    ) ? _c('v-btn', {
      staticClass: "px-5 white--text",
      attrs: {
        "depressed": "",
        "color": "#67BBDF"
      },
      on: {
        "click": function($event) {
          return _vm.onUnsupendStudent(
            student.id
          )
        }
      }
    }, [_vm._v("\n                                                    Unsuspend\n                                                ")]) : _vm._e(), _vm._v(" "), (
      student.disable_chat ==
      true
    ) ? _c('v-btn', {
      staticClass: "px-5 ml-2 white--text",
      attrs: {
        "depressed": "",
        "color": "#67BBDF"
      },
      on: {
        "click": function($event) {
          return _vm.onEnabledStudent(
            student.id
          )
        }
      }
    }, [_vm._v("\n                                                    Enable Chat\n                                                ")]) : _vm._e(), _vm._v(" "), (
      student.disable_chat ==
      false
    ) ? _c('v-btn', {
      staticClass: "px-5 ml-2 white--text",
      attrs: {
        "depressed": "",
        "color": "#ff647c"
      },
      on: {
        "click": function($event) {
          return _vm.onDisabledStudent(
            student.id
          )
        }
      }
    }, [_vm._v("\n                                                    Disable Chat\n                                                ")]) : _vm._e()], 1)], 1)], 1)], 1)
  }), 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.onDivert) ? _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    on: {
      "click:outside": function($event) {
        _vm.onDivert = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', {
          staticStyle: {
            "word-break": "break-word !important"
          }
        }, [_vm._v("\n                    Apakah Anda yakin ingin mengalihkan live class ini ke\n                    Live Class Zoom?\n                ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "blew",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.onDivertClass()
            }
          }
        }, [_vm._v("\n                        Ya\n                    ")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "darkFade",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.onDivert = false
            }
          }
        }, [_vm._v("\n                        Batal\n                    ")])], 1)], 1)]
      }
    }], null, false, 4266684386),
    model: {
      value: (_vm.onDivert),
      callback: function($$v) {
        _vm.onDivert = $$v
      },
      expression: "onDivert"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEndLive) ? _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    on: {
      "click:outside": function($event) {
        _vm.isEndLive = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', {
          staticStyle: {
            "word-break": "break-word !important"
          }
        }, [_vm._v("\n                    Apakah Anda yakin ingin menghentikan live class ini?\n                ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "blew",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.endLiveClass()
            }
          }
        }, [_vm._v("\n                        Ya\n                    ")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "darkFade",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.isEndLive = false
            }
          }
        }, [_vm._v("\n                        Batal\n                    ")])], 1)], 1)]
      }
    }], null, false, 749463257),
    model: {
      value: (_vm.isEndLive),
      callback: function($$v) {
        _vm.isEndLive = $$v
      },
      expression: "isEndLive"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQuiz) ? _c('v-dialog', {
    attrs: {
      "max-width": "360px"
    },
    on: {
      "click:outside": function($event) {
        _vm.showQuiz = false
      }
    },
    model: {
      value: (_vm.showQuiz),
      callback: function($$v) {
        _vm.showQuiz = $$v
      },
      expression: "showQuiz"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v("\n                Quiz " + _vm._s(_vm.dataQuiz.id) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v(" Kunci: " + _vm._s(_vm.dataQuiz.answer) + " ")]), _vm._v(" "), _c('v-card-text', [_vm._v(" Durasi: " + _vm._s(_vm.timer) + " Detik ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" Publish? ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showQuiz = false
      }
    }
  }, [_vm._v("\n                    Back\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onShowQuiz(_vm.dataQuiz.id)
      }
    }
  }, [_vm._v("\n                    Confirm\n                ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showResult) ? _c('v-dialog', {
    attrs: {
      "max-width": "360px"
    },
    on: {
      "click:outside": function($event) {
        _vm.showResult = false
      }
    },
    model: {
      value: (_vm.showResult),
      callback: function($$v) {
        _vm.showResult = $$v
      },
      expression: "showResult"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v("\n                Result Quiz " + _vm._s(_vm.result.id) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center"
  }, [_vm._v("Submission: " + _vm._s(_vm.result.total) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                A. " + _vm._s(_vm.result.sumA) + " siswa (" + _vm._s(_vm.result.a) + "%)")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                B. " + _vm._s(_vm.result.sumB) + " siswa (" + _vm._s(_vm.result.b) + "%)")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                C. " + _vm._s(_vm.result.sumC) + " siswa (" + _vm._s(_vm.result.c) + "%)")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                D. " + _vm._s(_vm.result.sumD) + " siswa (" + _vm._s(_vm.result.d) + "%)")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                E. " + _vm._s(_vm.result.sumE) + " siswa (" + _vm._s(_vm.result.e) + "%)")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                Jawaban: " + _vm._s(_vm.result.answer) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" Publish? ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showResult = false
      }
    }
  }, [_vm._v("\n                    Back\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.publishResult(_vm.result.id)
      }
    }
  }, [_vm._v("\n                    Confirm\n                ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.confirmSuspend.open) ? _c('v-dialog', {
    attrs: {
      "max-width": "360px"
    },
    on: {
      "click:outside": function($event) {
        _vm.confirmSuspend.open = false
      }
    },
    model: {
      value: (_vm.confirmSuspend.open),
      callback: function($$v) {
        _vm.$set(_vm.confirmSuspend, "open", $$v)
      },
      expression: "confirmSuspend.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.confirmSuspend.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.confirmSuspend.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmSuspend.open = false;
        _vm.confirmSuspend.title = null;
        _vm.confirmSuspend.function = null;
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.onSuspendStudent(_vm.confirmSuspend.function);
        _vm.confirmSuspend.open = false;
        _vm.confirmSuspend.title = null;
        _vm.confirmSuspend.function = null;
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c6c098b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class_teacher/components/LiveClassTeacherDetail.vue
// module id = 1856
// module chunks = 1